import React from "react";
import { VerticalSliderWrapper } from "./VerticalSlider.styled";

interface IVerticalSliderProps {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const VerticalSlider: React.FC<IVerticalSliderProps> = ({
  min = 0,
  max = 100,
  value,
  onChange,
  className,
}) => {
  return (
    <VerticalSliderWrapper
      type="range"
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      className={className}
      data-testid="vertical-slider"
    />
  );
};

export default VerticalSlider;
